
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
  } from '@chakra-ui/react'
  import ExpertDataService from "../../services/Expert";
export const DeleteModal = ({isOpen,onClose, id, func}:any) => {
  const deleteAssessments = () => {
    ExpertDataService.delete(id)
      .then((response: any) => {
        func(true);
       onClose();
      })
      .catch((e: Error) => {
        console.log(e);
      });
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Expert</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          Are you sure you want to remove expert?
          </ModalBody>

          <ModalFooter>
          <Button  bgColor='#327171' color={"white"} mr={3} onClick={deleteAssessments} >Delete</Button>
            <Button  bgColor='red' color={"white"} mr={3} onClick={onClose}>
              No
            </Button>
           
          </ModalFooter>
        </ModalContent>
      </Modal>
  )
}
